import UserDetail from "@/components/Details/UserDetail";
import UserManagementForm from "@/components/Forms/UserManagementForm";

const UserManagementDetail = () => {
    return (
        <UserDetail page="admin"/>
    )
}

export default UserManagementDetail;